import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Lock, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
const FAQS = [{
  q: '¿Esto funciona con niños muy rebeldes?',
  a: 'Sí, porque los niños más "rebeldes" suelen ser los que más reaccionan al estrés del grito. Al bajar el volumen y subir la estrategia, su resistencia baja.'
}, {
  q: '¿Tengo que leer mucho?',
  a: 'No. Está diseñado para padres ocupados, con puntos clave, tablas y guiones de lectura rápida.'
}, {
  q: '¿Es para todas las edades?',
  a: 'Sí, incluye secciones específicas divididas por etapas de desarrollo de los 2 a los 12 años.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'De forma inmediata en tu correo tras realizar el pago.'
}, {
  q: '¿Sirve si mi pareja no aplica el mismo método?',
  a: 'Sí, aunque lo ideal es la consistencia, el cambio en tu forma de dirigirte al niño transformará tu relación individual con él.'
}];
export function OfferSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-sage-50" data-id="element-63">
      <div className="max-w-3xl mx-auto px-6" data-id="element-64">
        {/* FAQ */}
        <div className="mb-20" data-id="element-65">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-10 text-center" data-id="element-66">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-67">
            {FAQS.map((faq, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-sage-100 shadow-sm" data-id="element-68">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-69">
                  <span className="font-semibold text-stone-900 pr-4" data-id="element-70">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-sage-500 transition-transform ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-71" />
                </button>
                <AnimatePresence data-id="element-72">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-73">
                      <div className="px-6 pb-5 text-stone-600" data-id="element-74">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>

        {/* Offer Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-8 md:p-12 text-center shadow-xl border-4 border-sage-100 relative overflow-hidden" data-id="element-75">
          <div className="absolute top-0 left-0 w-full h-2 bg-skyblue" data-id="element-76" />

          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-4" data-id="element-77">
            Recupera la paz en tu hogar hoy mismo
          </h2>
          <p className="text-lg text-stone-600 mb-10 max-w-xl mx-auto" data-id="element-78">
            Obtén el Ebook "Obediencia Sin Gritos" y todos los bonos de guiones
            rápidos por un pago único.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          type: 'spring',
          bounce: 0.4
        }} className="relative mb-12 z-10" data-id="element-79">
            <div className="absolute inset-0 bg-amber-100/60 blur-3xl rounded-full transform scale-110 -z-10" data-id="element-80" />
            <motion.img whileHover={{
            scale: 1.02,
            rotate: -1
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} src="https://cdn.magicpatterns.com/uploads/q1sG8tcaMnD7SkUycopjTS/obediencia_sin_grito_publicidad.png" alt="Ebook Obediencia Sin Gritos - El Método de los Neuro-Comandos" className="w-full max-w-lg mx-auto rounded-3xl shadow-2xl border-4 border-white" data-id="element-81" />
          </motion.div>

          <div className="bg-sage-50 rounded-2xl p-6 mb-8 inline-block border border-sage-200" data-id="element-82">
            <p className="text-sm text-sage-700 font-semibold uppercase tracking-wider mb-2" data-id="element-83">
              Precio Especial
            </p>
            <div className="flex items-start justify-center gap-1" data-id="element-84">
              <span className="text-2xl font-bold text-navy mt-1" data-id="element-85">$</span>
              <span className="text-6xl font-bold text-navy tracking-tight" data-id="element-86">
                6.39
              </span>
              <span className="text-xl text-sage-500 mt-auto mb-1 ml-1" data-id="element-87">
                USD
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-88">
            <CTAButton className="w-full md:w-auto" data-id="element-89" />
            <div className="flex items-center gap-4 text-sm text-stone-500 mt-2" data-id="element-90">
              <span className="flex items-center gap-1" data-id="element-91">
                <Lock className="w-4 h-4" data-id="element-92" /> Pago 100% Seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-93">
                <ShieldCheck className="w-4 h-4" data-id="element-94" /> Entrega Inmediata
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}